import { axios, baseURL } from './axios';
import { AwsApiFactory, Configuration } from '@subflow/api-client';

const config = new Configuration({
  basePath: baseURL,
});

export const awsApi = AwsApiFactory(config, baseURL, axios);
